import { useLayoutEffect } from 'react';

const useScrollOnNewRow = (elementId, isNewRow) => {
  useLayoutEffect(() => {
    const element = document.getElementById(elementId);
    if (element && isNewRow && element.scrollIntoView) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      });
    }
  });
  return null;
};

export default useScrollOnNewRow;
